import { useEffect, useState } from 'react'
import {
  Box,
  IconButton,
  Typography,
  Paper,
  Popover,
  Grid,
  Button,
} from '@mui/material'
import { ChevronLeft, ChevronRight } from '@mui/icons-material'

import {
  startOfWeek,
  endOfWeek,
  addDays,
  addWeeks,
  subWeeks,
  format,
  isSameDay,
  setMonth,
  setYear,
} from 'date-fns'

import { ptBR } from 'date-fns/locale'

export default function WeekNavigatorStyled({ onChange }) {
  const [currentDate, setCurrentDate] = useState(new Date())

  // Popover (seletor mês/ano)
  const [anchorEl, setAnchorEl] = useState(null)
  const [tempYear, setTempYear] = useState(new Date().getFullYear())

  const open = Boolean(anchorEl)

  const start = startOfWeek(currentDate, { weekStartsOn: 1 })
  const end = endOfWeek(currentDate, { weekStartsOn: 1 })

  const days = [...Array(7)].map((_, i) => addDays(start, i))

  // Notifica componente pai
  useEffect(() => {
    onChange?.({ start, end })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentDate])

  return (
    <>
      <Paper
        elevation={3}
        sx={{
          p: 2,
          borderRadius: 3,
          margin: 'auto',
        }}
      >
        {/* Header */}
        <Box display="flex" alignItems="center" justifyContent="center" mb={2}>
          <IconButton onClick={() => setCurrentDate(subWeeks(currentDate, 1))}>
            <ChevronLeft />
          </IconButton>

          {/* 🔥 Botão mês/ano */}
          <Box
            onClick={(e) => {
              setTempYear(currentDate.getFullYear())
              setAnchorEl(e.currentTarget)
            }}
            sx={{
              cursor: 'pointer',
              px: 2,
              py: 0.5,
              borderRadius: 2,
              transition: '0.2s',
              '&:hover': { backgroundColor: '#f5f5f5' },
            }}
          >
            <Typography variant="h6" fontWeight="bold">
              {format(start, 'MMMM yyyy', { locale: ptBR })}
            </Typography>
          </Box>

          <IconButton onClick={() => setCurrentDate(addWeeks(currentDate, 1))}>
            <ChevronRight />
          </IconButton>
        </Box>

        {/* Dias da semana */}
        <Box display="flex" justifyContent="center">
          {days.map((day, index) => {
            const isToday = isSameDay(day, new Date())

            return (
              <Box
                key={index}
                sx={{
                  textAlign: 'center',
                  flex: 1,
                  p: 1,
                  borderRadius: 2,
                  cursor: 'pointer',
                  backgroundColor: isToday ? '#1976d2' : 'transparent',
                  color: isToday ? '#fff' : 'inherit',
                  maxWidth: 100,
                  transition: '0.2s',
                  '&:hover': {
                    backgroundColor: isToday ? '#1565c0' : '#f5f5f5',
                  },
                }}
              >
                <Typography variant="caption" sx={{ opacity: 0.7 }}>
                  {format(day, 'EEE', { locale: ptBR })}
                </Typography>

                <Typography variant="body1" fontWeight="bold">
                  {format(day, 'dd')}
                </Typography>
              </Box>
            )
          })}
        </Box>
      </Paper>

      {/* 📅 Popover mês/ano */}
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Box sx={{ p: 2, width: 260 }}>
          {/* Header ano */}
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
          >
            <IconButton onClick={() => setTempYear(tempYear - 1)}>
              <ChevronLeft />
            </IconButton>

            <Typography fontWeight="bold">{tempYear}</Typography>

            <IconButton onClick={() => setTempYear(tempYear + 1)}>
              <ChevronRight />
            </IconButton>
          </Box>

          {/* Grid meses */}
          <Grid container spacing={1}>
            {[
              'Jan',
              'Fev',
              'Mar',
              'Abr',
              'Mai',
              'Jun',
              'Jul',
              'Ago',
              'Set',
              'Out',
              'Nov',
              'Dez',
            ].map((mes, index) => {
              const isSelected =
                currentDate.getMonth() === index &&
                currentDate.getFullYear() === tempYear

              const isCurrentMonth =
                new Date().getMonth() === index &&
                new Date().getFullYear() === tempYear

              return (
                <Grid item xs={3} key={index}>
                  <Button
                    fullWidth
                    size="small"
                    variant={isSelected ? 'contained' : 'text'}
                    onClick={() => {
                      const newDate = setMonth(
                        setYear(currentDate, tempYear),
                        index,
                      )
                      setCurrentDate(newDate)
                      setAnchorEl(null)
                    }}
                    sx={{
                      borderRadius: 2,
                      textTransform: 'none',
                      border: isCurrentMonth ? '1px solid #1976d2' : 'none',
                    }}
                  >
                    {mes}
                  </Button>
                </Grid>
              )
            })}
          </Grid>

          {/* Botão hoje */}
          <Box mt={2} textAlign="center">
            <Button
              size="small"
              onClick={() => {
                setCurrentDate(new Date())
                setAnchorEl(null)
              }}
            >
              Hoje
            </Button>
          </Box>
        </Box>
      </Popover>
    </>
  )
}
